<template lang="pug">
el-drawer(size="480px", :visible.sync="visible", :close-on-click-modal="false", @closed="reject")
  template(#title)
    .title 基本信息
  el-form(label-width="90px", label-position="left")
    el-form-item(label="姓名：")
      el-input(:value="info.name", readonly)
    el-form-item(label="工号：")
      el-input(:value="info.username", readonly)
    el-form-item(label="账号：")
      el-input(:value="info.username", readonly)
    el-form-item(label="性别：")
      el-input(:value="info.sex | sex", readonly)
    el-form-item(label="所属部门：")
      DeptInput(v-model="info.deptList", @click.native="onActive")
    el-form-item(label="负责部门：")
      DeptInput(:value="headDeptList", @click.native="openSelect($refs.head)")
      el-select.hidden-select(v-model="headId", ref="head", multiple)
        el-option(v-for="dept in info.deptList", :key="dept.deptId", :value="dept.deptId", :label="dept.deptName")
    el-form-item(label="主部门：")
      DeptInput.main-dep(:value="mainDeptList", @click.native="openSelect($refs.main)")
      i.el-icon-circle-close(v-if="mainId", @click="clearMain")
      el-select.hidden-select(v-model="mainId", ref="main")
        el-option(v-for="dept in info.deptList", :key="dept.deptId", :value="dept.deptId", :label="dept.deptName")
    el-form-item(label="账号状态：")
      el-switch.mt-8(v-model="info.isEnabled", :active-value="1", :inactive-value="0")
  .footer
    el-button(@click="close()") 取消
    el-button(type="primary", @click="submit()") 确定
</template>
<script>
import { asyncMixin } from "@/CommonDP/commons/asyncCom";
import DeptInput from "./dept-input";
import { openMember } from "@/CommonDP/components/chooseMember/leftCom";
import orgService from "@/CommonDP/service/org-service";
import { mapState } from "vuex";

export default {
  components: { DeptInput },
  filters: {
    sex(val) {
      return ["", "男", "女"][val];
    }
  },
  mixins: [asyncMixin],
  data() {
    return {
      visible: !false,
      info: {
        enterpriseId: null,
        enterpriseName: null,
        enterpriseStatus: null,
        enterpriseUserId: "5976",
        userId: "5ca7bcd4228a4c6bbf9b5f9bd51c8d35",
        name: "婧婧1",
        username: "13260450335",
        phone: "13260450335",
        createTime: null,
        sex: "2",
        isEnabled: 1,
        isExternal: null,
        deptList: [
          { deptId: "DEPT237585925968756736", deptName: "xx造价部", fullDeptName: "公司/xx造价部", isMain: 0, isHead: 1, rowID: "4092291613589504" },
          { deptId: "DEPT207143816942059520", deptName: "研发一部", fullDeptName: "公司/研发部/研发一部", isMain: 1, isHead: 0, rowID: "4092291613589504" }
        ],
        status: null,
        isSignature: 1,
        isJoin: null,
        checkInUser: "婧婧1",
        checkInDate: "2023-01-28 16:50:55",
        deptIds: null,
        joinStatus: null,
        isDelete: null,
        isHead: null,
        positionType: null,
        staffId: null,
        major: null,
        qualificaion: null,
        userStatus: null
      }
    };
  },
  computed: {
    ...mapState({
      enterpriseId: (state) => state.enterprise.enterpriseId
    }),
    deptIdMap() {
      const map = {};
      for (const dept of this.info.deptList) {
        map[dept.deptId] = dept;
      }
      return map;
    },
    mainId: {
      get() {
        return this.mainDeptList.map(({ deptId }) => deptId).join("");
      },
      set(val) {
        this.setDeptList("isMain", val ? [val] : "");
      }
    },
    mainDeptList() {
      return this.getFilter("isMain");
    },
    headDeptList() {
      return this.getFilter("isHead");
    },
    headId: {
      get() {
        return this.headDeptList.map(({ deptId }) => deptId) || [];
      },
      set(list) {
        this.setDeptList("isHead", list || []);
      }
    }
  },
  methods: {
    async submit() {
      const {
        enterpriseId,
        info: { isEnabled, userId, deptList = [] }
      } = this;
      const data = {
        userId,
        enterpriseId,
        isEnabled,
        deptList: deptList.map(({ deptId, isHead, isMain }) => ({
          deptId,
          isHead,
          isMain
        }))
      };
      await orgService.updateMemberDept(data);
      this.$emit("resolve");
      this.visible = false;
    },
    clearMain() {
      this.mainId = "";
    },
    setDeptList(key, data) {
      const ids = new Set(data);
      for (const dept of this.info.deptList) {
        Reflect.set(dept, key, ids.has(dept.deptId) ? 1 : 0);
      }
    },
    async onActive() {
      const {
        info: { deptList: list = [] }
      } = this;
      const _data = await openMember({
        codePri: ["Dept"],
        usersList: list.map(({ deptId, deptName }) => ({
          id: deptId,
          name: deptName,
          nodeId: deptId,
          deptId,
          deptName,
          selectName: deptName,
          selectCode: "Dept"
        }))
      });
      const data = _data.map((dept) => {
        const cache = this.deptIdMap[dept.deptId] || {};
        return {
          deptId: dept.id,
          deptName: dept.name,
          isMain: 0,
          isHead: 0,
          ...cache
        };
      });
      this.info.deptList = data;
    },
    openSelect(selectVm) {
      selectVm.visible = true;
    },
    getFilter(key) {
      return this.info.deptList.filter((item) => !!item[key]);
    },
    open() {
      this.visible = true;
    },
    close() {
      this.visible = false;
    }
  }
};
</script>
<style lang="scss" scoped>
.el-form {
  margin: 0 16px 0 16px;
  flex: 1 1;
  overflow: auto;
  /deep/ .el-form-item__content {
    line-height: 1;
  }
}
.el-select {
  display: block;
}
.main-dep {
  & + i {
    color: #999;
    position: absolute;
    right: 8px;
    top: 0;
    bottom: 0;
    margin-block: auto;
    height: 14px;
    z-index: 1;
    opacity: 0;
    transition: all 0.2s;
    cursor: pointer;
  }
  &:hover + i,
  & + i:hover {
    opacity: 1;
    color: #666;
  }
}
.title {
  font-size: 18px;
}
.hidden-select {
  height: 0 !important;
  visibility: hidden;
  border: none;
  display: block;
  position: absolute;
  z-index: -1;
  overflow: hidden;
  top: 0;
  left: 0;
  right: 0;
}
/deep/ .el-drawer__body {
  display: flex;
  flex-flow: column nowrap;
}
.footer {
  padding: 8px 16px;
  text-align: right;
}
</style>
